import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=cff903ce&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=cff903ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff903ce",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PublicLogo: require('/Users/pam/Documents/Projects/cmp/cmp/city-manager-platform/components/public/Logo.vue').default,PublicContact: require('/Users/pam/Documents/Projects/cmp/cmp/city-manager-platform/components/public/Contact.vue').default})
